export default angular.module('flatastic.filters.new-line-to-br', [])

.filter('newLineToBr', function () {
  return function (text) {
      return text.split("\n").join("<br>");
  };
})

.name
